import axios from 'axios'

export type Inputs = {
  email: string
  challenge: string
  seccode: string
  subscription: boolean
}

export const emailAxios = axios.create({
  baseURL: `${process.env.GATSBY_CAMPAIGN_URL}/`,
})

export const submitEmail = async (values: Inputs) => {
  try {
    const url = '/campaign/subscribe-content-hub'
    const { data } = await emailAxios.post(url, values)
    return data
  } catch (e: any) {
    let errorMsg = ''
    if (e.response.status === 422) {
      errorMsg = e.response.data
    }
    throw errorMsg
  }
}
